import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, {} from 'react';
import { cx, } from '../utils/ReactUtils.js';
import { getComponentPositionClass, } from './components.js';
function Spinner() {
    return (_jsxs("svg", { className: "h-4 w-4 animate-spin", viewBox: "0 0 24 24", fill: "none", "aria-hidden": true, children: [_jsx("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }), _jsx("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 0 1 8-8v3a5 5 0 0 0-5 5H4z" })] }));
}
export function Button(props) {
    const { children, position = 'normal', className = '', buttonClassName = '', variant = 'primary', size = 'md', fullWidth = false, disabled = false, loading = false, leftIcon, rightIcon, } = props;
    const positionClass = getComponentPositionClass(position);
    const isDisabled = disabled || loading;
    const sizeClass = {
        sm: 'text-sm px-3',
        md: 'text-sm px-4 min-w-[80px]',
        lg: 'text-base px-5 min-w-[120px]',
    }[size];
    const variantClass = {
        primary: 'bg-tym-primary text-white border-transparent',
        secondary: 'bg-tym-green text-white border-transparent',
        danger: 'bg-error text-white border-transparent',
        outline: 'bg-white text-gray-900 border-tym-component-border-default hover:border-tym-component-border-hover',
        ghost: 'bg-transparent text-gray-900 border-transparent hover:bg-gray-100',
    }[variant];
    const leading = loading ? _jsx(Spinner, {}) : leftIcon;
    const controlClassName = cx('inline-flex items-center justify-center gap-2 rounded-md font-medium', 'h-10', // matches Textbox/Select control height (px-3 py-2 ~= 40px)
    'border', 'transition duration-200 ease-out', 'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-tym-primary', 'shadow-sm', isDisabled
        ? 'opacity-50 cursor-not-allowed'
        : 'cursor-pointer hover:shadow-md hover:brightness-110 active:brightness-90', fullWidth ? 'w-full' : 'w-auto', sizeClass, variantClass, buttonClassName);
    const content = (_jsxs(_Fragment, { children: [leading ? _jsx("span", { className: "shrink-0", children: leading }) : null, _jsx("span", { className: "truncate", children: children }), rightIcon ? _jsx("span", { className: "shrink-0", children: rightIcon }) : null] }));
    let control;
    if ('href' in props && props.href !== undefined) {
        const { href, target, rel, onClick, tabIndex, children: _children, position: _position, className: _className, buttonClassName: _buttonClassName, variant: _variant, size: _size, fullWidth: _fullWidth, disabled: _disabled, loading: _loading, leftIcon: _leftIcon, rightIcon: _rightIcon, ...rest } = props;
        control = (_jsx("a", { ...rest, href: href, target: target, rel: target === '_blank'
                ? rel ?? 'noopener noreferrer'
                : rel, tabIndex: isDisabled ? -1 : tabIndex, "aria-disabled": isDisabled ? true : undefined, "aria-busy": loading ? true : undefined, className: controlClassName, onClick: event => {
                if (isDisabled) {
                    event.preventDefault();
                    return;
                }
                onClick?.(event);
            }, children: content }));
    }
    else {
        const { type = 'button', children: _children, position: _position, className: _className, buttonClassName: _buttonClassName, variant: _variant, size: _size, fullWidth: _fullWidth, disabled: _disabled, loading: _loading, leftIcon: _leftIcon, rightIcon: _rightIcon, href: _href, target: _target, ...rest } = props;
        control = (_jsx("button", { ...rest, type: type, disabled: isDisabled, "aria-busy": loading ? true : undefined, className: controlClassName, children: content }));
    }
    return (_jsx("div", { className: `w-full ${positionClass} ${className}`, children: control }));
}
//# sourceMappingURL=Button.js.map